var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosingBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10.9359V12.6526C18.3334 13.1193 17.95 13.5026 17.475 13.5026H15.8667C14.9667 13.5026 14.1417 12.8443 14.0667 11.9443C14.0167 11.4193 14.2167 10.9276 14.5667 10.5859C14.875 10.2693 15.3 10.0859 15.7667 10.0859H17.475C17.95 10.0859 18.3334 10.4693 18.3334 10.9359Z",
    fill: "#407BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8165 12.0513C12.7415 11.1763 13.0582 10.318 13.6915 9.69297C14.2248 9.1513 14.9665 8.83464 15.7665 8.83464H16.2415C16.4748 8.83464 16.6665 8.64297 16.6332 8.40964C16.4082 6.79297 15.0082 5.54297 13.3332 5.54297H4.99984C3.15817 5.54297 1.6665 7.03463 1.6665 8.8763V14.7096C1.6665 16.5513 3.15817 18.043 4.99984 18.043H13.3332C15.0165 18.043 16.4082 16.793 16.6332 15.1763C16.6665 14.943 16.4748 14.7513 16.2415 14.7513H15.8665C14.2832 14.7513 12.9498 13.568 12.8165 12.0513ZM10.8332 10.3346H5.83317C5.4915 10.3346 5.20817 10.0596 5.20817 9.70963C5.20817 9.35963 5.4915 9.08464 5.83317 9.08464H10.8332C11.1748 9.08464 11.4582 9.36797 11.4582 9.70963C11.4582 10.0513 11.1748 10.3346 10.8332 10.3346Z",
    fill: "#407BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8419 3.73464C12.0585 3.95964 11.8669 4.29297 11.5502 4.29297H5.02521C4.11687 4.29297 3.26687 4.55964 2.55854 5.01797C2.23354 5.2263 1.79187 5.0013 1.95021 4.64297C2.41687 3.5513 3.50854 2.79297 4.76687 2.79297H9.45021C10.4169 2.79297 11.2752 3.13464 11.8419 3.73464Z",
    fill: "#407BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosingBalance);
export default __webpack_public_path__ + "static/media/closing_balance.96993cbfea72d3b91b40537156581755.svg";
export { ForwardRef as ReactComponent };